"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _env = _interopRequireDefault(require("../../core/env"));

/*
JSBridge大致流程:
web调用_call,
_call将函数push到队列_sendMessageQueue, 通知app执行_fetchQueue
app取到任务队列,使用_handleMessageFromToutiao()执行每个任务
_handleMessageFromToutiao会把执行结果用_setResultIframe的方式返回客户端
*/
(function () {
  var UTF8 = {
    encode: function encode(b) {
      b = b || "";
      b = b.replace(/\r\n/g, "\n");
      var a = "";

      for (var e = 0; e < b.length; e++) {
        var d = b.charCodeAt(e);

        if (d < 128) {
          a += String.fromCharCode(d);
        } else {
          if (d > 127 && d < 2048) {
            a += String.fromCharCode(d >> 6 | 192);
            a += String.fromCharCode(d & 63 | 128);
          } else {
            a += String.fromCharCode(d >> 12 | 224);
            a += String.fromCharCode(d >> 6 & 63 | 128);
            a += String.fromCharCode(d & 63 | 128);
          }
        }
      }

      return a;
    },
    decode: function decode(a) {
      var b = "";
      var d = 0;
      var e = c1 = c2 = 0;

      while (d < a.length) {
        e = a.charCodeAt(d);

        if (e < 128) {
          b += String.fromCharCode(e);
          d++;
        } else {
          if (e > 191 && e < 224) {
            c2 = a.charCodeAt(d + 1);
            b += String.fromCharCode((e & 31) << 6 | c2 & 63);
            d += 2;
          } else {
            c2 = a.charCodeAt(d + 1);
            c3 = a.charCodeAt(d + 2);
            b += String.fromCharCode((e & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
            d += 3;
          }
        }
      }

      return b;
    }
  };
  var base64encodechars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

  function base64encode(g) {
    if (g === undefined) {
      return g;
    }

    var c, e, a;
    var f, d, b;
    a = g.length;
    e = 0;
    c = "";

    while (e < a) {
      f = g.charCodeAt(e++) & 255;

      if (e == a) {
        c += base64encodechars.charAt(f >> 2);
        c += base64encodechars.charAt((f & 3) << 4);
        c += "==";
        break;
      }

      d = g.charCodeAt(e++);

      if (e == a) {
        c += base64encodechars.charAt(f >> 2);
        c += base64encodechars.charAt((f & 3) << 4 | (d & 240) >> 4);
        c += base64encodechars.charAt((d & 15) << 2);
        c += "=";
        break;
      }

      b = g.charCodeAt(e++);
      c += base64encodechars.charAt(f >> 2);
      c += base64encodechars.charAt((f & 3) << 4 | (d & 240) >> 4);
      c += base64encodechars.charAt((d & 15) << 2 | (b & 192) >> 6);
      c += base64encodechars.charAt(b & 63);
    }

    return c;
  }

  function isEmptyObject(b) {
    for (var a in b) {
      return false;
    }

    return true;
  }

  ; //工具函数结束

  function _revertArgs(key, params) {
    var min_image_size = 100;

    if (key == "share") {
      if (params && !isEmptyObject(params)) return params;
      var title = "",
          desc = "",
          icon = "",
          title_ele = document.querySelector("title"),
          desc_ele = document.querySelector("meta[name=description]"),
          apple_touch_icon_ele = document.querySelector("link[rel*=apple-touch-icon]"),
          rel_icon_ele = document.querySelector("link[rel*=shortcut]");
      if (title_ele) title = title_ele.innerText;
      if (desc_ele) desc = desc_ele.content;
      if (rel_icon_ele) icon = rel_icon_ele.href;
      if (apple_touch_icon_ele) icon = apple_touch_icon_ele.href;

      if (!icon) {
        var imgs = document.querySelectorAll("body img");

        for (var i = 0; i < imgs.length; i++) {
          var img = imgs[i];

          if (img.naturalWidth > min_image_size && img.naturalWidth > min_image_size) {
            icon = img.src;
            break;
          }

          ;
        }
      }

      ;
      return {
        "platform": "weixin_moments",
        "url": location.href,
        "title": title,
        "desc": desc,
        "image": icon
      };
    }

    ;
    return params;
  }

  ;

  var _sendMessageQueue = [],
      _receiveMessageQueue = [],
      _callback_count = 1000,
      _callback_map = {},
      _event_hook_map = {},
      _readyMessageIframe,
      //call方法被调用时,会修改其src 为 bytedance://dispatch_message/, 告知app执行_fetchQueue
  _setResultIframe,
      //返回值通过修改该iframe src实现
  _CUSTOM_PROTOCOL_SCHEME = 'bytedance://';

  if (_env.default.isInSuper) {
    _CUSTOM_PROTOCOL_SCHEME = 'bds://';
  } //web: 创建iframe的准备队列


  function _createQueueReadyIframe() {
    _setResultIframe = document.createElement('iframe');
    _setResultIframe.id = '__ToutiaoJSBridgeIframe_SetResult';
    _setResultIframe.style.display = 'none';
    document.body.appendChild(_setResultIframe);
    _readyMessageIframe = document.createElement('iframe');
    _readyMessageIframe.id = '__ToutiaoJSBridgeIframe';
    _readyMessageIframe.style.display = 'none';
    document.body.appendChild(_readyMessageIframe);
  }

  ; //app->web:取出队列中的消息，并清空接收队列

  function _fetchQueue() {
    var messageQueueString = JSON.stringify(_sendMessageQueue);
    _sendMessageQueue = [];

    _setResultValue('SCENE_FETCHQUEUE', messageQueueString);

    return messageQueueString;
  }

  ; //app->web:执行JS函数,并将结果返回客户端

  function _handleMessageFromApp(message) {
    var msg_type = message['__msg_type'],
        msg_params = message['__params'],
        msg_event_id = message['__event_id'],
        msg_callback_id = message['__callback_id'],
        ret;

    if (msg_type == 'callback') {
      ret = {
        '__err_code': 'cb404'
      };

      if (typeof msg_callback_id === 'string' && typeof _callback_map[msg_callback_id] === 'function') {
        ret = _callback_map[msg_callback_id](msg_params);
        delete _callback_map[msg_callback_id];
      }

      ;
    } else if (msg_type == 'event') {
      ret = {
        '__err_code': 'ev404'
      };

      if (typeof msg_event_id === 'string' && typeof _event_hook_map[msg_event_id] === 'function') {
        ret = _event_hook_map[msg_event_id](msg_params);
      }
    }

    ;

    _setResultValue('SCENE_HANDLEMSGFROMTT', JSON.stringify(ret));

    return JSON.stringify(ret);
  }

  ;

  function _setResultValue(scene, result) {
    //+result id待添加
    setTimeout(function () {
      _setResultIframe.src = _CUSTOM_PROTOCOL_SCHEME + 'private/setresult/' + scene + '&' + base64encode(UTF8.encode(result));
    }, 0);
  }

  ; //web->app: 将客户端功能push到队列,告诉客户端有新任务,等待客户端 _fetchQueue

  function _call(func, params, callback, sdk_version) {
    sdk_version = sdk_version || 2;
    if (!func || typeof func !== 'string') return;
    if ((0, _typeof2.default)(params) !== 'object') params = {};
    params = _revertArgs(func, params);
    var callbackID = (_callback_count++).toString();
    if (typeof callback === 'function') _callback_map[callbackID] = callback;
    var _msg_string = {
      'JSSDK': sdk_version,
      'func': func,
      'params': params,
      '__msg_type': 'call',
      '__callback_id': callbackID
    }; //将消息添加到发送队列，iframe的准备队列为bytedance://dispatch_message/

    _sendMessageQueue.push(_msg_string);

    _readyMessageIframe.src = _CUSTOM_PROTOCOL_SCHEME + 'dispatch_message/';
  }

  ; //web: 自定义事件和回调

  function _on(event, callback) {
    if (!event || typeof event !== 'string' || typeof callback !== 'function') return;
    _event_hook_map[event] = callback;

    _call("addEventListener", {
      name: event
    }, null);
  }

  ;

  function _trigger(event, argv) {
    if (typeof _event_hook_map[event] !== 'function') return;

    _event_hook_map[event](argv);
  }

  ;
  var jsbObj = {
    call: _call,
    on: _on,
    _fetchQueue: _fetchQueue
  };

  if (_env.default.isInSuper) {
    jsbObj._handleMessageFromApp = _handleMessageFromApp;
    window.JSBridge = jsbObj;
  } else {
    jsbObj._handleMessageFromToutiao = _handleMessageFromApp;
    window.ToutiaoJSBridge = jsbObj;
  } //对外暴露toutiao, 隐藏ToutiaoJSBridge


  window.toutiao = {
    trigger: _trigger
  };

  function _initToutiao() {
    var latent_keys = {
      "pageStateChange": "page_state_change",
      "isVisible": "is_visible",
      "isLogin": "is_login",
      "uploadImage": "upload_image"
    },
        public_fn = ["appInfo", "login", "comment", "close", "isVisible", "isLogin", "playVideo"],
        private_fn = ["isAppInstalled", "open", "share", "systemShare", "pay", "pageStateChange", "downloadApp", "openThirdApp", "uploadImage", "addChannel", "gallery", "copyToClipboard"],
        protected_fn = [],
        all_fn = public_fn.concat(private_fn),
        sdk_match = navigator.userAgent.match(/JSSDK\/([\d.]+)/i),
        sdk_version = sdk_match ? sdk_match[1] : 1;

    if (sdk_match) {
      all_fn = all_fn.concat(["config"]);
    } else {
      //旧版app, 不支持config.直接返回支持列表
      toutiao['config'] = function (arg) {
        var callback_success = getParams(arg, "success");

        if (callback_success) {
          return callback_success({
            code: 1,
            supportList: {
              call: public_fn
            }
          });
        }
      };
    }

    ;

    function getParams(arg, key) {
      return key == "params" ? arg : arg[key];
    }

    ;
    all_fn.forEach(function (key) {
      toutiao[key] = function (arg) {
        arg = arg || {};
        var params = getParams(arg, "params"),
            callback_error = getParams(arg, "error"),
            callback_success = getParams(arg, "success"),
            callback_fail = getParams(arg, "fail"); //params['clientID'] ="xxxx";

        key = latent_keys[key] || key;

        _call(key, params, function (o) {
          o = o || {};
          var code = o.code; //delete o.code;
          //没有返回值, 认为成功

          if (isEmptyObject(o)) {
            code = 1;
          } else if (code == undefined) {
            //返回值不为空,且忘了传code,认为成功
            code = 1;
          }

          ;
          if (code == -1 && callback_error) callback_error(o);
          if (code == 0 && callback_fail) callback_fail(o);
          if (code == 1 && callback_success) callback_success(o);
        }, sdk_version);
      };
    });
  }

  _createQueueReadyIframe();

  _initToutiao();
})();